interface CityData {
  name: string;
  whatsappGroupLink: string;
}

export const citiesList: CityData[] = [
  {
    name: "Mumbai",
    whatsappGroupLink: "https://chat.whatsapp.com/B6zBva1mwP7DDHfH1x1RKW",
  },
  {
    name: "Delhi",
    whatsappGroupLink: "https://chat.whatsapp.com/Bn4RO3dMvuw8PCmZGPLYKk",
  },
  {
    name: "Bengaluru",
    whatsappGroupLink: "https://chat.whatsapp.com/BbiJChNNBfZCGzQKWvMXB4",
  },
  {
    name: "Pune",
    whatsappGroupLink: "https://chat.whatsapp.com/HuGzTcxsC61KudvnlZNft0",
  },
  {
    name: "Kolkata",
    whatsappGroupLink: "https://chat.whatsapp.com/FwR5BNKphefGVqLDpJruN3",
  },
  {
    name: "Hyderabad",
    whatsappGroupLink: "https://chat.whatsapp.com/HaIxSzfGGSE0Hrm1fHpfeO",
  },
];
